import { Module, Mutation, VuexModule, Action } from 'vuex-module-decorators';

import container from '@/container';
import { Product } from '@/dto';
import { encodeParams } from '@/core/helpers';
import { FetchServiceContract, CONTRACTS } from '@/core/contracts';

interface ProductsState {
    list: Product[];
    isLoading: boolean;
    current?: Product;
}

const fetchService = container.get<FetchServiceContract>(CONTRACTS.FetchService);

@Module({ name: 'products', namespaced: true })
export default class ProductsModule extends VuexModule implements ProductsState {
    public _list: Product[] = [];
    public _isLoading: boolean = false;
    public _current?: Product = undefined;

    get list() {
        return this._list;
    }
    get isLoading() {
        return this._isLoading;
    }
    get current() {
        return this._current;
    }

    @Action
    public async fetchProducts(args: { contextId: string, filter?: string, top?: number }) {
        this.setProductsLoading(true);

        const { contextId, ...query } = args;
        const url = `/contexts/${contextId}/products?${encodeParams(query)}`;
        const products = await fetchService.get<Product[]>(url);

        this.setProducts(products);
        this.setProductsLoading(false);
    }
    @Action
    public selectProduct(payload?: Product) {
        this.setCurrentProduct(payload);
    }
    @Action
    public clearProducts() {
        this.setProducts([]);
    }

    @Mutation
    private setProducts(payload: Product[]) {
        this._list = payload;
    }
    @Mutation
    private setProductsLoading(payload: boolean) {
        this._isLoading = payload;
    }
    @Mutation
    private setCurrentProduct(payload?: Product) {
        this._current = payload;
    }
}
